var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsefulLinkVariant1 = function SvgUsefulLinkVariant1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19.5,
    r: 18.5,
    fill: "url(#useful-link-variant-1_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#useful-link-variant-1_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#useful-link-variant-1_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29ACD6",
    fillOpacity: 0.35,
    fillRule: "evenodd",
    d: "M33.25 55.25c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#useful-link-variant-1_svg__d)",
    d: "M33.25 55.25c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#useful-link-variant-1_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#useful-link-variant-1_svg__f)",
    d: "M25.615 19.5C19.753 19.5 15 24.201 15 30s4.753 10.5 10.615 10.5c.765 0 1.385-.613 1.385-1.37 0-.756-.62-1.37-1.385-1.37-4.333 0-7.846-3.474-7.846-7.76s3.513-7.76 7.846-7.76c.765 0 1.385-.614 1.385-1.37s-.62-1.37-1.385-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#useful-link-variant-1_svg__g)",
    d: "M40.385 19.5c-.765 0-1.385.613-1.385 1.37 0 .756.62 1.37 1.385 1.37 4.333 0 7.846 3.474 7.846 7.76s-3.513 7.76-7.846 7.76c-.765 0-1.385.614-1.385 1.37s.62 1.37 1.385 1.37C46.247 40.5 51 35.799 51 30s-4.753-10.5-10.615-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#useful-link-variant-1_svg__h)",
    d: "M25.615 28.63c-.764 0-1.384.614-1.384 1.37s.62 1.37 1.384 1.37h14.77c.764 0 1.384-.614 1.384-1.37s-.62-1.37-1.384-1.37z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "useful-link-variant-1_svg__a",
    x1: 0,
    x2: 37.788,
    y1: 38,
    y2: 1.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#207894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "useful-link-variant-1_svg__d",
    x1: 8.25,
    x2: 58.275,
    y1: 5.25,
    y2: 55.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "useful-link-variant-1_svg__f",
    x1: 33.303,
    x2: 58.782,
    y1: 44.974,
    y2: 2.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "useful-link-variant-1_svg__g",
    x1: 33.303,
    x2: 58.782,
    y1: 44.974,
    y2: 2.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "useful-link-variant-1_svg__h",
    x1: 33.303,
    x2: 58.782,
    y1: 44.974,
    y2: 2.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "useful-link-variant-1_svg__c",
    width: 99,
    height: 99,
    x: -16.25,
    y: -19.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1152_16954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1152_16954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "useful-link-variant-1_svg__e",
    width: 52,
    height: 37,
    x: 12,
    y: 16.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1152_16954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1152_16954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "useful-link-variant-1_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 0h60v60H3z"
  })))));
};
export { SvgUsefulLinkVariant1 as ReactComponent };